import React from 'react';
import { useSelector } from 'react-redux';

import StyledToolTip from '@rental-manager/components/StyledTooltip';
import Text from '@zg-rentals/multibrand-ui/lib/Text';

import { RootState } from '../../../../store/types';

const DepositDateTooltipComponent = (): JSX.Element | null => {
  const { enableFastPayments } = useSelector((state: RootState) => state.payments.landlord.property.userConfig);

  return (
    <StyledToolTip className="Dashboard-ledger-tooltip" iconName="help-circle-fill">
      <Text>
        {enableFastPayments
          ? 'Rent payments are typically deposited within two business days. In some cases, deposits follow a standard five-business-day timeline.'
          : 'Because it takes the banks up to 5 business days to process a payment, weekends and holidays extends the total processing time.'}
      </Text>
    </StyledToolTip>
  );
};

export default DepositDateTooltipComponent;
